import { gql } from '@apollo/client';

export const GET_YEF_DATE = gql`
  query getYEFDate($clientId: Number!) {
    getYEFDate(clientId: $clientId) @rest(path: "document.json/client/:clientId/find/TAX") {
      results {
        file {
          displayName
        }
        taxDocumentType
        documentDate
      }
    }
  }
`;

export const CLIENT_YEARLY_DATA = gql`
  query ClientYearlyData($clientId: ID!) {
    client(id: $clientId) {
      yearlyData {
        year
        yearEndFinancialPackage
      }
    }
  }
`;
